"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("./js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { viewBox: "0 0 1152 1152" },
      _react2.default.createElement("path", { fill: "#07F792", d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z" }),
      _react2.default.createElement("path", { fill: "#CBFFE9", d: "M853.3 301.2l-5-7.1-247.2 247.4V297.1h-21.8c-72.5.4-143.6 27.8-193.7 72.9l-76.3-79.7-7.1 7c-74.1 73.3-116.3 171.2-117.1 275.6s40.1 202.6 113.2 277l7.9 7 253-247.1v247.9H581c72.4-.3 134.6-28.2 184.7-73.7l76.7 76.7 7-6.9c154.9-152.5 157.9-394.5 3.9-552.6zm-294 35.5v217H334.5c9.9-117.9 107.2-206.8 224.8-217zm-250.1-18.2l63.6 63.3C324 432.3 291.6 501 291.4 576.7v18.9h257.1l-243 235.5c-134-143.5-132.4-370.9 3.7-512.6zm291.9 506v-229h220.7c-8.2 119.9-101.5 218.8-220.7 229zm241.4 8.1l-61.4-63.7c49.5-51.6 82.6-121.9 82.2-199.2v-16H617.6l228.5-230c134.1 143.6 132.4 367.1-3.6 508.9z" })
    )
  );
};

WrappedIcon.displayName = 'AdobeMediaOptimizerColorDark';
exports.default = WrappedIcon;

